import { Tag } from "@silversea-ssc/ui-components-react";
import { TagsList } from "@/ui/post/Tags";
import { useRefinementList, UseRefinementListProps } from "react-instantsearch";
import styles from "./TagsFilter.module.scss";

type Props = Pick<UseRefinementListProps, "attribute" | "limit"> & {
  className?: string;
  dark?: boolean;
};

const TagsFilter: React.FC<Props> = ({ className, attribute, limit, dark }) => {
  const { items, refine } = useRefinementList({
    attribute: attribute,
    limit: limit,
    sortBy: ["count:desc", "name:asc"]
  });
  const tagBackgroundColor = (isRefined: boolean) => {
    if (isRefined) return "neutral05";
    return dark ? "neutral15" : "titanium";
  };

  return (
    <TagsList className={className} data-content-name="tags_filter">
      {items.map((item) => (
        <li
          key={item.value}
          onClick={() => refine(item.value)}
          className={styles.action}
          data-content-piece={`tag_filter_${item.value}`}
        >
          <Tag
            backgroundColor={tagBackgroundColor(item.isRefined)}
            size="large"
          >
            {item.value}
          </Tag>
        </li>
      ))}
    </TagsList>
  );
};

export default TagsFilter;
